import { faEdit, faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import ContactDelete from "./ContactDelete";
import ContactDetailPopup from "./ContactDetailPopup";

const ContactActionButton = ({ id, handleDelete }) => {
  const [showDelete, setShowDelete] = useState(false);
  const [showView, setShowView] = useState(false);
  const params = useParams();
  const businessId = params?.business_id;

  const toggleShowModal = () => {
    setShowView(!showView);
  };

  const toggleDeleteModal = () => {
    setShowDelete(!showDelete);
  };
  return (
    <>
      <span>
        <FontAwesomeIcon
          onClick={toggleShowModal}
          icon={faEye}
          size="1x"
          data-toggle="modal"
          data-target="#contactDetail"
        />
        <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
        <Link to={`/business/${businessId}/edit-contact?id=${id}`}>
          <FontAwesomeIcon icon={faEdit} size="1x" />
        </Link>
        <span></span>&nbsp;&nbsp;/&nbsp;&nbsp;
        <FontAwesomeIcon
          onClick={toggleDeleteModal}
          icon={faTrash}
          size="1x"
          data-toggle="modal"
          data-target="#deleteContact"
        />
      </span>

      {showDelete && (
        <ContactDelete
          contactId={id}
          toggleDeleteModal={toggleDeleteModal}
          handleDelete={handleDelete}
          showDelete={showDelete}
        />
      )}

      {showView && (
        <ContactDetailPopup
          contactId={id}
          toggleShowModal={toggleShowModal}
          showView={showView}
        />
      )}
    </>
  );
};

export default ContactActionButton;
